import { mask } from 'vue-the-mask';
import { Constants } from '../../components/common/Constants.js';

export default {
  directives: {
    mask
  },
  data () {
		return {
			constants: Constants,
			validationRules: {
				required: v => !!v || window.$vue.$t('common.validations.required_field'), //'Es necesario completar este campo',
				requiredBoolean: v => !(!v && v!==false) || window.$vue.$t('common.validations.required_field'), //'Es necesario completar este campo',
				maxLength(v, maximum) { return (v || '').length <= maximum || 'El campo excede la longitud máxima permitida (' + maximum + ' caracteres)'; },
				rangeInt(v, minimum, maximum) { return ((v || '') >= minimum && (v || '') <= maximum) || window.$vue.$t('common.validations.required_field') + ' [ ' + minimum + ' - ' + maximum + ' ]'; },
				email: v => !v || /.+@.+\..+/.test(v) || window.$vue.$t('common.validations.invalid_field'),
				date: v => !v || this.validateDate(v) || 'No es una fecha válida dd/mm/aaaa',
				time: v => !v || this.validateTime(v) || 'No es una hora válida hh::mm:ss',
			},
    }
  },
  computed: {
  },
  methods: {
		formatDate(value) {
			return !value ? '' : new Date(value).toLocaleDateString();
		},
		formatOnlyDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatFullDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			var result = new Date(value).toLocaleString([this.$i18n.locale, 'en'], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			return result.charAt(0).toUpperCase() + result.slice(1);
		},
		formatLongDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatShortDate(value) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit' });
		},
		formatLongDateTime(value, is24hours) {
			if (!value) return "";
			if (typeof value === 'string') {
				value = new Date(value.split('[')[0]);
			}
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false : undefined });
		},
		formatShortDateTime(value, is24hours) {
			if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false : undefined });
		},
		formatTime(value, is24hours) {
			if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { hour: '2-digit', minute: '2-digit', hour12: is24hours ? false : undefined });
		},
		validateJson(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (e) {
				e;
			}
			return false;
		},
    getTimeWithZoneOffset (date) {
        if (!date) return null

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
				}

        if (typeof date === 'string') {
            date = new Date(date.split('[')[0]); //la entrada es ISO string
				}

				return date.toLocaleTimeString([this.$i18n.locale, "en"], { hour: '2-digit', minute: '2-digit', hour12: false });
    },
		getDateAsMs(date) {
			if (!date) return 0;
      if (typeof date === 'number')
        date = new Date(date); //la entrada son milisegundos
			if (typeof date === 'string')
				date = new Date(date.split('[')[0]); //la entrada es ISO string
			return date.getTime();
		},
		flattenJSONObject(object) {
			let result = {};

			function recurse(cur, prop) {
				if (Object(cur) !== cur) {
					result[prop] = cur;
				} else if (Array.isArray(cur)) {
					for (var i = 0, l = cur.length; i < l; i++) {
						recurse(cur[i], prop + "[" + i + "]");
						if (l == 0)
							result[prop] = [];
					}
				} else {
					let isEmpty = true;
					for (var p in cur) {
						isEmpty = false;
						recurse(cur[p], prop ? prop + "." + p : p);
					}
					if (isEmpty && prop) {
						result[prop] = {};
					}
				}
			}
			recurse(object, "");
			return result;
		},
  }
}